import "./New_User_Trial.css";

const NewUserTrialModal = ({ isOpen, onClose, freeBenefits }) => {
  if (!isOpen) return null;

  const data =
    Array.isArray(freeBenefits) && freeBenefits.length > 0 ? freeBenefits : [];

  return (
    <div className="app-container">
      <div className="card_newuser">
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>

        <p style={{ marginBottom: "0px" }}>Welcome to</p>
        <p className="title-newuser-message">Motion Learning App</p>

        <div className="benefits-section-newuser">
          <h6 className="benefits-header">
            Free Benefits{" "}
            <span className="highlight">(ALWAYS FREE, ALWAYS YOURS)</span>
          </h6>

          <div className="benefits-list">
            <div className="connecting-line"></div>

            {data.map((benefit, index) => (
              <div className="benefit-item" key={index}>
                <div className="checkmark">✓</div>
                <div>
                  <h2 className="benefit-title">
                    {benefit.name?.toUpperCase() || "N/A"}
                  </h2>
                  <p className="benefit-description">
                    {benefit.description || "No description available"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="trial-section">
          <span className="gift-icon">🎁</span>
          <p className="trial-text">
            2-DAY FREE TRIAL OF VIDEO CONTENT UNLOCKED!
          </p>
        </div>

        <button className="trial-button" onClick={onClose}>
          START YOUR 2-DAY FREE TRIAL
        </button>
      </div>
    </div>
  );
};

export default NewUserTrialModal;
